import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LandingGateSupporter {
  private resolveReady!: () => void;

  readonly ready: Promise<void> = new Promise(resolve => {
    this.resolveReady = resolve;
  });

  markReady(): void {
    this.resolveReady();
  }
}